import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EnvService } from 'src/app/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class CommonFileService {

  imgUrl = new BehaviorSubject("");
  constructor(private httpClient: HttpClient,public environment: EnvService) { }

  getpresignedUrl(obj): any {
    return this.httpClient.post(this.environment.adminUrl + `user/api/user/s3signedurl`, obj,{ headers: { hideLoader: 'true' } });
  }

  uploadImagetocloud(url, file): any {
    const headers = new HttpHeaders({
      'skip-interceptor': '',
      hideLoader: 'true'
    });
    return this.httpClient.put(url, file, { headers: headers });
  }


  // base64upload(base64, reqireddetails): any {
  //   fetch(base64)
  //     .then(res => res.blob())
  //     .then(blob => {
  //       let file = new File([blob], "Company", { type: "image/jpeg" });
  //       this.getpresignedUrl(reqireddetails).subscribe(data => {
  //         let signedurl = data.preSignedurl;
  //         this.uploadImagetocloud(signedurl, file).subscribe(e => {
  //           let imgurl = data.baseurl + data.file_path;
  //           this.imgUrl.next(imgurl);
  //           return imgurl;
  //         })
  //       })
  //     });
  // }

  //  fileupload(file, reqireddetails): any {
  //       this.getpresignedUrl(reqireddetails).subscribe(data => {
  //         let signedurl = data.preSignedurl;
  //         this.uploadImagetocloud(signedurl, file).subscribe(e => {
  //           let imgurl =data.baseurl + data.file_path;
  //           this.imgUrl.next(imgurl);
  //           return imgurl;
  //         })
  //       })
  // }

  

}
